module.exports = __webpack_public_path__ + "img/OpenSi.5ea92bbd.jpg";